import { Client_Event_Name, } from '@quiz-buzz/common'
import {page_header_style, Standard_Page_Layout, sub_header_style} from '../Components/Standard_Page_Layout'
import { Button } from '../Components/Button'
import { Game_Results_Component } from '../Components/Game_Results_Component'
import { player_machine_actor } from '../App/main'

export function Player_Finished() {

	const send_quit = () => player_machine_actor.send({type: Client_Event_Name.quit})

	const header = (
		<>
			<div className={page_header_style}>Finished</div>
			<div className={sub_header_style}>
				congratulations to the winner!
			</div>
		</>
	)
	
	const content = <Game_Results_Component />

	const controls = (
		<div className='two_buttons'>
			<Button text="Exit" button_style="Primary" onClick={send_quit} />
		</div>
	)
	return (
		<Standard_Page_Layout
			header={header}
			content={content}
			controls={controls}
		/>
	)
}


